import {
  Divider,
  HStack,
  Heading,
  Stack,
  useDisclosure,
} from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { TrackedButton } from '$/components/common/Button/TrackedButton';
import { StyledScrollWrapper } from '$/components/common/StyledScrollWrapper';
import { useAuthorization } from '$/components/core/Authentication/hooks/useAuthorization';
import { useIsMobile } from '$/hooks/useIsMobile';
import { InviteStudentModal } from '$/pages/StudentsPage/components/InviteStudentModal';
import { StudentCardList } from '$/pages/StudentsPage/components/StudentCardList';
import { StudentInvitationCardList } from '$/pages/StudentsPage/components/StudentInvitationCardList';
import { studentInvitationsQuery } from '$/services/usecases/invitation/queries';
import {
  schoolClassesQuery,
  studentsQuery,
} from '$/services/usecases/school/queries';

export const StudentsPage = () => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const { hasPermission } = useAuthorization();
  const { data: studentsData } = useQuery(studentsQuery);
  const { data: studentInvitationsData } = useQuery(studentInvitationsQuery);
  const { data: schoolClassesData } = useQuery(schoolClassesQuery());
  const inviteStudentModal = useDisclosure();

  return (
    <Stack
      w='full'
      {...(!isMobile && {
        layerStyle: 'DashboardSection',
      })}
    >
      <StyledScrollWrapper>
        <Stack
          gap='6'
          overflowY='auto'
          w='full'
          {...(!isMobile && {
            p: '7',
          })}
        >
          <HStack justify='space-between'>
            <Heading as='h1' fontSize='3xl'>
              {t('school.students.title')}
            </Heading>
            {hasPermission('School_Manage_Students') && (
              <TrackedButton
                h='10'
                fontSize='sm'
                onClick={inviteStudentModal.onOpen}
                contentName='School'
                contentPiece='SchoolStudents'
                contentTarget='InviteStudent'
              >
                {t('school.students.inviteStudentButton')}
              </TrackedButton>
            )}
          </HStack>
          <StudentCardList
            students={studentsData?.response ?? []}
            schoolClassOptions={schoolClassesData?.response ?? []}
          />
          <Divider borderColor='border' />
          <Heading as='h2' fontSize='2xl'>
            {t('school.students.invitationsTitle')}
          </Heading>
          <StudentInvitationCardList
            studentInvitations={studentInvitationsData?.response ?? []}
            schoolClassOptions={schoolClassesData?.response ?? []}
          />
        </Stack>
      </StyledScrollWrapper>
      <InviteStudentModal
        isOpen={inviteStudentModal.isOpen}
        onClose={inviteStudentModal.onClose}
        schoolClassOptions={schoolClassesData?.response ?? []}
      />
    </Stack>
  );
};
